import axios from 'axios';
import { getToken, isAuthenticated } from './auth';
import { getPathApp } from '../utils/util';

const pathurl = getPathApp(window);

export default class HttpService {
    // Metodo dummy para o sonarlint nao reclamar
    getInstance() {
        return this.instance;
    }

    constructor(baseURL, apiKey) {
        this.instance = axios.create({
            baseURL
        });

        this.instance.interceptors.request.use(async (config) => {
            if (isAuthenticated()) {
                const token = getToken();

                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                config.headers['Access-Control-Allow-Origin'] = '*';
                config.headers['Access-Control-Allow-Methods'] = '*';
                config.headers['Access-Control-Allow-Headers'] = '*';
                config.headers['Access-Control-Allow-Credentials'] = '*';
                if (apiKey) {
                    config.headers['x-api-key'] = apiKey;
                }
                return config;
            } else {
                return new Promise((resolve) => {
                    if (window.location.pathname !== `${pathurl}/login`) {
                        window.location.pathname = `${pathurl}/login`;
                    }
                    resolve();
                });
            }
        });
    }
}
